// import { IMask } from "react-imask";

import { IMask } from "react-imask";

/* eslint-disable no-param-reassign */
// export const maskCnpj = (v: string) => {
//   v = v.replace(/\D/g, "");

//   if (v.length <= 11) {
//     v = v.replace(/(\d{3})(\d)/, "$1.$2");
//     v = v.replace(/(\d{3})(\d)/, "$1.$2");
//     v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
//   } else {
//     v = v.substring(0, 14);
//     v = v.replace(/^(\d{2})(\d)/, "$1.$2");
//     v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
//     v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
//     v = v.replace(/(\d{4})(\d)/, "$1-$2");
//   }

//   return v;
// };

// export default (type: "cnpj", input: string) => {
//   return type === "cnpj" && maskCnpj(input);
// };

/**
 * https://stackoverflow.com/a/10452789/8786986
 * @param args
 */
const masker = ({
  masked,
  transform,
  maskDefault
}: {
  masked: any;
  transform?: any;
  maskDefault?: any;
}) =>
  // eslint-disable-next-line func-names
  (function () {
    const mask = IMask.createPipe(masked, IMask.PIPE_TYPE.UNMASKED, IMask.PIPE_TYPE.MASKED);

    const unmask = IMask.createPipe(masked, IMask.PIPE_TYPE.MASKED, IMask.PIPE_TYPE.UNMASKED);

    const onChange = (e: any) => {
      const unmasked = unmask(e.target.value);
      const newValue = mask(unmasked);
      e.target.value = newValue;
    };

    return {
      mask,
      onChange,
      transform: transform || unmask,
      unmask,
      maskDefault: maskDefault || mask
    };
  })();

export const cpfOrCnpjMask = masker({
  masked: {
    mask: [
      {
        mask: "000.000.000-00",
        type: "CPF"
      },
      {
        mask: "00.000.000/0000-00",
        type: "CNPJ"
      }
    ],
    dispatch: (appended: any, dynamicMasked: { compiledMasks: any[]; value: any }) => {
      const cpfMask = dynamicMasked.compiledMasks.find(({ type }) => type === "CPF");

      const cnpjMask = dynamicMasked.compiledMasks.find(({ type }) => type === "CNPJ");

      if (`${dynamicMasked.value}${appended}`.length > cpfMask.mask.length) {
        return cnpjMask;
      }

      return cpfMask;
    }
  }
});

export const phoneMask = masker({
  masked: {
    mask: [
      {
        mask: "(00) 0000-0000",
        phone: "landline"
      },
      {
        mask: "(00) 00000-0000",
        phone: "mobile"
      }
    ],
    dispatch: (appended: any, dynamicMasked: { compiledMasks: any[]; value: any }) => {
      const landlineMask = dynamicMasked.compiledMasks.find(
        ({ phone }) => phone === "landline"
      );

      const mobileMask = dynamicMasked.compiledMasks.find(({ phone }) => phone === "mobile");

      if (`${dynamicMasked.value}${appended}`.length > landlineMask.mask.length) {
        return mobileMask;
      }

      return landlineMask;
    }
  }
});

export const currencyMask = masker({
  masked: {
    mask: "R$ num{,}cents",
    blocks: {
      num: {
        mask: Number,
        signed: true,
        thousandsSeparator: ".",
        mapToRadix: [""],
        scale: 0
      },
      cents: {
        mask: "00",
        normalizeZeros: true,
        padFractionalZeros: true
      }
    }
  },
  transform: (value: any) => {
    return Number(currencyMask.unmask(value).replace(",", "."));
  },
  maskDefault: (value: number) => {
    return currencyMask.mask(value.toFixed(2).replace(".", ","));
  }
});
